// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e68fd8f2","826":"eeb32c82"}[chunkId] + ".chunk.js";
};